var exports = {
  "item": "xa15a2ab7--cd7238--item",
  "with-icon": "xa15a2ab7--cd7238--with-icon",
  "atelier": "xa15a2ab7--cd7238--atelier",
  "atm": "xa15a2ab7--cd7238--atm",
  "automatic-gates": "xa15a2ab7--cd7238--automatic-gates",
  "aquapark": "xa15a2ab7--cd7238--aquapark",
  "baby-sitting": "xa15a2ab7--cd7238--baby-sitting",
  "balcony": "xa15a2ab7--cd7238--balcony",
  "bank-department": "xa15a2ab7--cd7238--bank-department",
  "beauty-shop": "xa15a2ab7--cd7238--beauty-shop",
  "banya": "xa15a2ab7--cd7238--banya",
  "basement": "xa15a2ab7--cd7238--basement",
  "bath": "xa15a2ab7--cd7238--bath",
  "big-balcony": "xa15a2ab7--cd7238--big-balcony",
  "bowling": "xa15a2ab7--cd7238--bowling",
  "buffet": "xa15a2ab7--cd7238--buffet",
  "cafe": "xa15a2ab7--cd7238--cafe",
  "canal": "xa15a2ab7--cd7238--canal",
  "car-service": "xa15a2ab7--cd7238--car-service",
  "car-wash": "xa15a2ab7--cd7238--car-wash",
  "central-reception": "xa15a2ab7--cd7238--central-reception",
  "clothes-studio": "xa15a2ab7--cd7238--clothes-studio",
  "cinema": "xa15a2ab7--cd7238--cinema",
  "cargolift": "xa15a2ab7--cd7238--cargolift",
  "cond": "xa15a2ab7--cd7238--cond",
  "conference-room": "xa15a2ab7--cd7238--conference-room",
  "dishwasher": "xa15a2ab7--cd7238--dishwasher",
  "electricity": "xa15a2ab7--cd7238--electricity",
  "exhibition-warehouse-complex": "xa15a2ab7--cd7238--exhibition-warehouse-complex",
  "fitness-centre": "xa15a2ab7--cd7238--fitness-centre",
  "fridge": "xa15a2ab7--cd7238--fridge",
  "furniture": "xa15a2ab7--cd7238--furniture",
  "game-room": "xa15a2ab7--cd7238--game-room",
  "garage": "xa15a2ab7--cd7238--garage",
  "gas": "xa15a2ab7--cd7238--gas",
  "hotel": "xa15a2ab7--cd7238--hotel",
  "internet": "xa15a2ab7--cd7238--internet",
  "inspection-pit": "xa15a2ab7--cd7238--inspection-pit",
  "kitchen": "xa15a2ab7--cd7238--kitchen",
  "lift": "xa15a2ab7--cd7238--lift",
  "market": "xa15a2ab7--cd7238--market",
  "notary-office": "xa15a2ab7--cd7238--notary-office",
  "office-space": "xa15a2ab7--cd7238--office-space",
  "park": "xa15a2ab7--cd7238--park",
  "parking": "xa15a2ab7--cd7238--parking",
  "pharmacy": "xa15a2ab7--cd7238--pharmacy",
  "phone": "xa15a2ab7--cd7238--phone",
  "photo-studio": "xa15a2ab7--cd7238--photo-studio",
  "pool": "xa15a2ab7--cd7238--pool",
  "radiator": "xa15a2ab7--cd7238--radiator",
  "rink": "xa15a2ab7--cd7238--rink",
  "secure": "xa15a2ab7--cd7238--secure",
  "shower": "xa15a2ab7--cd7238--shower",
  "slot-machines": "xa15a2ab7--cd7238--slot-machines",
  "tire": "xa15a2ab7--cd7238--tire",
  "toilet": "xa15a2ab7--cd7238--toilet",
  "tv": "xa15a2ab7--cd7238--tv",
  "warehouse": "xa15a2ab7--cd7238--warehouse",
  "washing": "xa15a2ab7--cd7238--washing",
  "water": "xa15a2ab7--cd7238--water",
  "trash": "xa15a2ab7--cd7238--trash",
  "light": "xa15a2ab7--cd7238--light",
  "entry-by-pass": "xa15a2ab7--cd7238--entry-by-pass",
  "extinguishing_system": "xa15a2ab7--cd7238--extinguishing_system",
  "video-surveillance": "xa15a2ab7--cd7238--video-surveillance",
  "entrance-door": "xa15a2ab7--cd7238--entrance-door",
  "interior-door": "xa15a2ab7--cd7238--interior-door",
  "bathroom-door": "xa15a2ab7--cd7238--bathroom-door",
  "no-thresholds-at-entrance": "xa15a2ab7--cd7238--no-thresholds-at-entrance",
  "no-thresholds-at-entrance-to-flat": "xa15a2ab7--cd7238--no-thresholds-at-entrance-to-flat",
  "ramp-at-entrance": "xa15a2ab7--cd7238--ramp-at-entrance",
  "lift-at-entrance": "xa15a2ab7--cd7238--lift-at-entrance",
  "spacious-elevator": "xa15a2ab7--cd7238--spacious-elevator",
  "icon": "xa15a2ab7--cd7238--icon",
};

module.exports = exports;
